import TestsBlock from './TestsBlock.vue';

export default TestsBlock;



// WEBPACK FOOTER //
// ./src/pages/profile/components/info/components/block/components/legend/components/testsblock/index.ts